import {Component, Input, OnInit,} from '@angular/core';
import * as _sh from 'lodash';
import {DataCenterService} from "../../../service/data-center.service";
import {forkJoin as observableForkJoin} from "rxjs";
import {AppConfigService} from "../../../service/app-config.service";
import {RequestDataService} from "../../../service/request-data.service";
import {ConfirmModalService} from "../../../service/confirm-modal.service";
import {UserInfoService} from "../../../service/user-info.service";


@Component({
  selector: 'app-tran-business-report',
  templateUrl: './tran-business-report.component.html',
  styleUrls: ['./tran-business-report.component.scss']
})
export class TranBusinessReportComponent implements OnInit {

  @Input() parentData;

  //按钮和输入框状态
  btnAndInputState = {
    targetSaveVisit: false,//保存
    auditVisit: false,//审核
    addTargetBtnVisit: false,//结算明细新增按钮
    deleteTargetBtnVisit: false,//结算明细删除按钮
  }

  // 项目顺序是否能调整
  canMove = true;

  // 报表明细
  msTranBusinessReport: any = [];
  // msTranBusinessTargetDetail: any = [];
  public searchState: boolean = false;//false表示未开始查询

  constructor(
    private dataCenterService: DataCenterService,
    private appConfigService: AppConfigService,
    private requestService: RequestDataService,
    private confirmModal: ConfirmModalService,
    private userInfoService: UserInfoService
  ) {
  }

  round(num, digits = 2) {
    return Math.round(num * 10 ** digits) / 10 ** digits;
  }

  // 返回
  gotoBack(): void {
    this.parentData.data = {};
    this.parentData.conditionColumns = {};
    this.parentData.formType = 'listForm';
    this.parentData.actionArray = [];
    this.dataCenterService.refreshDataCenterInStorage();
  }

  calcularSummary() {
    const rows = this.msTranBusinessReport;
    if (!rows || rows.length === 0) {
      return;
    }
    // 有小计行的客户集合
    const subtotalCusts = {};
    rows.forEach(r => {
      if (r.level === 1 && r.CUST_ID) subtotalCusts[r.CUST_ID] = true;
    });
    // 按客户聚合项目行的业务字段（实际收入/开票税金/资金占用/配送成本）
    const custAgg = {};
    rows.forEach(r => {
      if (r.level === 2 && r.CUST_ID) {
        let a = custAgg[r.CUST_ID];
        if (!a) {
          a = custAgg[r.CUST_ID] = { INCOME: 0, TAX_AMOUNT: 0, CAPITAL_OCCUPATION: 0, COST: 0 };
        }
        a.INCOME += (+r.INCOME) || 0;
        a.TAX_AMOUNT += (+r.TAX_AMOUNT) || 0;
        a.CAPITAL_OCCUPATION += (+r.CAPITAL_OCCUPATION) || 0;
        a.COST += (+r.COST) || 0;
      }
    });
    // 总计累计
    const SUM = { INCOME: 0, TAX_AMOUNT: 0, CAPITAL_OCCUPATION: 0, COST: 0, NUMBER_OF_PERSONNEL: 0, LABOR_COST: 0, COMPENSATION: 0, COMPENSATION_ALREADY_DEDUCTED: 0, OTHER_EXPENSES: 0, TOTAL_COST: 0, COST_OF_MEMBRANE_PURCHASE: 0, REVENUE_FROM_RECYCLED_MEMBRANE: 0, OPERATIONAL_INCOME: 0 };
    rows.forEach(r => {
      if (r.level === 0) {
        return;
      }
      if (r.level === 1 && r.CUST_ID) {
        // 小计行：业务字段取项目汇总；客户级费用（人力/赔付/其他/购膜/回收膜）保留手填值
        const a = custAgg[r.CUST_ID] || { INCOME: 0, TAX_AMOUNT: 0, CAPITAL_OCCUPATION: 0, COST: 0 };
        r.INCOME = this.round(a.INCOME);
        r.TAX_AMOUNT = this.round(a.TAX_AMOUNT);
        r.CAPITAL_OCCUPATION = this.round(a.CAPITAL_OCCUPATION);
        r.COST = this.round(a.COST);
        this.computeRowTotals(r);
        this.addToSum(SUM, r);
      } else if (r.level === 2 && r.CUST_ID && !subtotalCusts[r.CUST_ID]) {
        // 单项目客户（无小计行）：项目行即客户行，整行计入总计
        this.computeRowTotals(r);
        this.addToSum(SUM, r);
      } else {
        // 多项目客户的明细行：只计算自身总成本/营运收益，不计入总计（已并入小计）
        this.computeRowTotals(r);
      }
    });
    // 总计行
    const total = rows[0];
    if (total) {
      _sh.each(SUM, (v, k) => { total[k] = this.round(v); });
      total.GROSS_MARGIN = this.round(total.OPERATIONAL_INCOME / total.INCOME, 4);
      total.GROSS_MARGIN_VARIANCE = this.round(total.GROSS_MARGIN - ((+total.TARGET_POST_TAX_GROSS_MARGIN) || 0), 4);
      total.VARIANCE_AMOUNT = this.round(total.INCOME * total.GROSS_MARGIN_VARIANCE);
    }
  }

  // 计算单行总成本/营运收益/毛利率（包含客户级费用）
  computeRowTotals(row) {
    const income = (+row.INCOME) || 0;
    const tax = (+row.TAX_AMOUNT) || 0;
    const cap = (+row.CAPITAL_OCCUPATION) || 0;
    const cost = (+row.COST) || 0;
    const labor = (+row.LABOR_COST) || 0;
    const comp = (+row.COMPENSATION) || 0;
    const compDed = (+row.COMPENSATION_ALREADY_DEDUCTED) || 0;
    const other = (+row.OTHER_EXPENSES) || 0;
    const membrane = (+row.COST_OF_MEMBRANE_PURCHASE) || 0;
    const recycled = (+row.REVENUE_FROM_RECYCLED_MEMBRANE) || 0;
    // 总成本 = 开票税金 + 配送成本 + 资金占用 + 人力成本 + 赔付 - 已扣回赔付 + 其他费用
    row.TOTAL_COST = this.round(tax + cost + cap + labor + comp - compDed + other);
    // 营运收益 = 实际收入 - 总成本 - 购膜成本 + 回收膜钱
    row.OPERATIONAL_INCOME = this.round(income - row.TOTAL_COST - membrane + recycled);
    row.GROSS_MARGIN = this.round(row.OPERATIONAL_INCOME / income, 4);
    row.GROSS_MARGIN_VARIANCE = this.round(row.GROSS_MARGIN - ((+row.TARGET_POST_TAX_GROSS_MARGIN) || 0), 4);
    row.VARIANCE_AMOUNT = this.round(income * row.GROSS_MARGIN_VARIANCE);
  }

  // 累加一行到总计
  addToSum(sum, row) {
    ['INCOME', 'TAX_AMOUNT', 'CAPITAL_OCCUPATION', 'COST', 'NUMBER_OF_PERSONNEL', 'LABOR_COST', 'COMPENSATION', 'COMPENSATION_ALREADY_DEDUCTED', 'OTHER_EXPENSES', 'TOTAL_COST', 'COST_OF_MEMBRANE_PURCHASE', 'REVENUE_FROM_RECYCLED_MEMBRANE', 'OPERATIONAL_INCOME'].forEach(k => {
      sum[k] += (+row[k]) || 0;
    });
  }

  // 保存
  reportSave() {
    //暂存不需要检查
    // if (!this.checkData()) {
    //   return;
    // }
    this.calcularSummary();
    let msTranBusinessReportList = [];
    this.msTranBusinessReport.forEach((item, index) => {
      let newItem = {};
      _sh.each(item, (value, key) => {
        const newKey = _sh.camelCase(key);
        newItem[newKey] = value;
      });
      msTranBusinessReportList.push(newItem);
    });

    if (this.parentData.modeType == "modify") {
      let queryData = {
        'userId': this.userInfoService.getUserInfo().USER_ID
      }
      this.requestService.doActionByHdbsthor("AppApi/MsTranBusinessReportController", "modifyReport", queryData, msTranBusinessReportList, false, 'hdbsthor_JieLiv2', 'appToken').subscribe(res => {
        if (res.status == 500) {
          this.confirmModal.show('error', {
            'title': '执行错误',
            'content': res.error.message
          });
        } else if (res) {
          this.gotoBack();
          this.confirmModal.show('success', {
            'title': '保存成功',
          });
        }
      });
    }
  }

  //整理保存/新增数据
  formatMainToEntity(pForm) {
    let entity: any = {};
    _sh.each(pForm, (item) => {
      const column = _sh.camelCase(_sh.get(item, 'column'));
      entity[column] = _sh.get(item, 'model');
      let columnGroup = _sh.get(item, 'columnGroup', null);
      _sh.each(columnGroup, (oneGroupColumn) => {
        const itemColumn = _sh.camelCase(_sh.get(oneGroupColumn, 'column'));
        entity[itemColumn] = _sh.get(oneGroupColumn, 'model');
      });
    });
    return entity;
  }

  async ngOnInit() {
    //按钮和输入框的权限
    this.updateVisit();
    let modeType = this.parentData.modeType;
    // 获取查询条件
    let yearMonth = this.parentData.searchCondition[0].code;

    if (modeType == "modify") {
      const res = await observableForkJoin(
        this.requestService.getDataByCondition(this.appConfigService.config.sql_path + '/report/tran_business_report/modify.json', { 'YEAR_MONTH': yearMonth }),//配送业务报表
      ).toPromise();

      // 报表明细
      this.msTranBusinessReport = _sh.get(res, [0, 'data']);
      this.msTranBusinessReport.forEach((item, index) => {
        item['input'] = false; //是否可以输入
        item['inputCost'] = false; //客户级费用字段（人力/赔付/其他/购膜/回收膜）是否可以输入
        item['visible'] = false;
        if (item['CUST_ID'])
          if (item['PRO_ID']) {
            item['level'] = 2;
            if (item['REPORT_STATE'] == "ADD") {
              item['input'] = true;
              item['inputCost'] = true;
            }
          }else{
            item['level']=1
            if (item['REPORT_STATE'] == "ADD") item['inputCost'] = true; //小计行可编辑客户级费用
            item['background-color'] = "yellow";
          }
        else{
          item['level']=0
          item['visible']= true;
          item['background-color'] = "deepskyblue";
        }
      })

      // 选中的显示：按客户(CUST_ID)关联，避免单项目客户（无小计行）被错误展开
      // 规则：选中小计 → 显示该客户全部项目；选中项目 → 显示该项目及其客户小计；选中总计 → 全部显示
      let ids = [];
      _sh.each(this.parentData.id, (item) => {
        ids.push(item['id']);
      });
      const selectedRows = this.msTranBusinessReport.filter(r => ids.indexOf(r['REPORT_ID']) > -1);
      // 总计始终显示，其余默认隐藏
      this.msTranBusinessReport.forEach(r => { r['visible'] = (r.level === 0); });
      if (selectedRows.some(r => r.level === 0)) {
        // 选中总计 → 全部显示
        this.msTranBusinessReport.forEach(r => { r['visible'] = true; });
      } else {
        // 选中的小计 → 展开该客户所有项目
        const expandCusts = {};
        selectedRows.forEach(r => { if (r.level === 1 && r['CUST_ID']) expandCusts[r['CUST_ID']] = true; });
        this.msTranBusinessReport.forEach(r => {
          if (ids.indexOf(r['REPORT_ID']) > -1) {
            r['visible'] = true;
          } else if (r.level === 1 && r['CUST_ID']) {
            // 小计行：同客户有项目被选中时显示
            if (selectedRows.some(s => s.level === 2 && s['CUST_ID'] === r['CUST_ID'])) {
              r['visible'] = true;
            }
          } else if (r.level === 2 && r['CUST_ID'] && expandCusts[r['CUST_ID']]) {
            // 选中了该客户的小计 → 显示该客户全部项目
            r['visible'] = true;
          }
        });
      }

      this.calcularSummary();
    }
  }

  //检查数据
  checkData() {


    //todo 必填数据检查
    let amountFlag = false;
    this.msTranBusinessReport.forEach((item) => {
      if (item['TARGET_REVENUE'] == null || item['TARGET_REVENUE'] == "" ) {
        this.confirmModal.show('error', {
          'title': '执行错误',
          'content': "项目名称为" + item['PRO_NAME'] + "的目标收入为空！"
        });
        amountFlag = true;
        return false;
      }
      if  (item['TARGET_POST_TAX_GROSS_MARGIN'] == null || item['TARGET_POST_TAX_GROSS_MARGIN'] == "" ){
        this.confirmModal.show('error', {
          'title': '执行错误',
          'content': "项目名称为" + item['PRO_NAME'] + "的税后毛利率为空！"
        });
        amountFlag = true;
        return false;
      }
    })
    return !amountFlag;

  }

  //按钮和输入框的权限
  updateVisit() {
    // 根据按钮的类型区分
    // this.parentData.modeType
    if (this.parentData.modeType == 'add' || this.parentData.modeType == 'modify') {//添加修改
      this.btnAndInputState.targetSaveVisit = true;
      this.btnAndInputState.addTargetBtnVisit = true;
      this.btnAndInputState.deleteTargetBtnVisit = true;
      // this.formVisable(['结算单号','结算序号'], false, false);
    } else if (this.parentData.modeType == 'audit') {//审核
      this.btnAndInputState.auditVisit = true;
      this.canMove = false;
    }
  }

  inputChange($event,OneData) {
    // 实际收入变化时重算开票税金/资金占用
    if (OneData.INCOME != null && OneData.INCOME !== "") {
      OneData.INCOME = this.round(OneData.INCOME);
      if (OneData.COM_TYPE !== "VIRTUAL") {
        OneData.TAX_AMOUNT = this.round(OneData.INCOME * 0.0926);
        OneData.CAPITAL_OCCUPATION = this.round(OneData.INCOME * 0.01 * 1.5);
      }else{
        OneData.TAX_AMOUNT = 0;
        OneData.CAPITAL_OCCUPATION = 0;
      }
    }
    this.calcularSummary();
  }

  putForward(oneColumn) {
    let num = this.msTranBusinessReport.indexOf(oneColumn);
    if (oneColumn.level === 1){
      // 找到上一个客户开始的下标
      let f = num-1;
      while (this.msTranBusinessReport[f].level === 2) f--;
      if (f>0){
        // 找到操作客户结束的下标
        let m = 1;
        while (num+m<this.msTranBusinessReport.length && this.msTranBusinessReport[num+m].level === 2) m++;
        const slice = this.msTranBusinessReport.splice(num, m);
        this.msTranBusinessReport.splice(f, 0, ...slice);
      }
    } else {
      let a = this.msTranBusinessReport[num - 1];
      if (a.level === 2) {
        this.msTranBusinessReport[num - 1] = oneColumn;
        this.msTranBusinessReport[num] = a;
      }
    }
  }

  putItBack(oneColumn) {
    let num = this.msTranBusinessReport.indexOf(oneColumn);
    if (oneColumn.level === 1){
      // 找到下一个客户开始的下标
      let m = 1;
      while (num+m<this.msTranBusinessReport.length && this.msTranBusinessReport[num+m].level === 2) m++;
      if (num+m<this.msTranBusinessReport.length) {
        const slice = this.msTranBusinessReport.splice(num, m);
        let d = num + 1;
        while (d<this.msTranBusinessReport.length && this.msTranBusinessReport[d].level === 2) d++;
        this.msTranBusinessReport.splice(d, 0, ...slice);
      }
    }else {
      let a = this.msTranBusinessReport[num + 1];
      if (a.level === 2) {
        this.msTranBusinessReport[num + 1] = oneColumn;
        this.msTranBusinessReport[num] = a;
      }
    }
  }

  async updateIncomeCost(oneColumn){
    this.searchState = true;
    const res = await observableForkJoin(
      this.requestService.getDataByCondition(
        this.appConfigService.config.sql_path + '/report/tran_business_report/query_income_cost.json',
        { 'YEAR_MONTH': oneColumn.YEAR_MONTH,'PRO_ID':oneColumn.PRO_ID }
      ),//配送业务报表
    ).toPromise();
    // 报表明细
    let data = _sh.get(res, [0, 'data']);
    if (data){
      oneColumn.COST = data[0].cost;
      oneColumn.INCOME = data[0].income;
      console.log(oneColumn);
      this.inputChange(null,oneColumn);
    }
    this.searchState = false;
  }
}

